import styled from 'styled-components';
import { Drawer as BoltDrawer } from '@sainsburys-tech/bolt';
export var Drawer = styled(BoltDrawer).withConfig({
  displayName: "DrawerCreditOptionsstyles__Drawer",
  componentId: "sc-1ij3hms-0"
})([".paypal-drawer{text-align:left;h2{font-size:1rem;}ol{list-style-type:decimal;margin:0 0 1rem 1.5rem;padding:0 0 1rem;}p{margin-bottom:1.5rem;}table{margin-bottom:1.5rem;td{border-bottom:none;padding-bottom:1rem;}td,th{padding-left:1rem;}}}"]);